// Services/fetchInactiveUsers.js
import { USERS } from "../Constants/Endpoints";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchInactiveUsers = async (nextToken = null) => {
  // NO pasamos headers aquí; el interceptor ya agrega Authorization desde localStorage.logindata
  const method = "GET";
  const qs = nextToken ? `?nextToken=${encodeURIComponent(nextToken)}` : "";

  const resp = await ApiRequestInterceptor(`${USERS.usersInactive}${qs}`, method);

  if (resp.code === 200) {
    const data = resp.data || {};
    return {
      statusCode: 200,
      items: Array.isArray(data.items) ? data.items : [],
      nextToken: data.nextToken || null,
      count: typeof data.count === "number" ? data.count : (data.items?.length || 0),
    };
  }

  if (resp.code === 401) return { statusCode: 401, message: "No autorizado" };
  if (resp.code === 403) return { statusCode: 403, message: resp.data?.message || "Requiere rol administrador" };

  return { statusCode: resp.code || 500, message: resp.data?.message || "Error al obtener usuarios inactivos" };
};